import React from 'react'
import SplitPanel from '../SplitPanel/split_panel'
import { useStaticQuery, graphql } from "gatsby"

const PersonalisationPreview = ({ data }) => {
  const previewPersonaliseSkus = useStaticQuery(graphql`
    query PreviewPersonaliseQuery {
      allPreviewPersonaliseSku {
        nodes {
          sku
          locations
          isLuggage
          isMe
          isEmbos
          images {
            positionId
            url
          }
        }
      }
    }
  `);
  
  const previewPersonaliseSkuData = previewPersonaliseSkus.allPreviewPersonaliseSku.nodes.find(val => val.sku === data?.Personalisation?.SKU)
  
    return (
        <SplitPanel
            header={data?.Subheading}
            title={data?.Heading}
            body={data?.Body}
            // link={splitPanel1?.link} 
            addPersonalisationOptionOn={true}
            color={data?.Theme?.panel_theme?.Background}
            font={data}
            personalisationSelection={data?.Personalisation}
            Image={{
                alternativeText: '',
                mime: '',
                name: '',
                isStatic: true,
                url: 'https://cdn.july.com/personalisation/cases/carry-new/back/04.png'
            }}
            link={{
                to: data.link,
                label: data?.CTA
            }}
            previewPersonaliseSkuData={previewPersonaliseSkuData}
        />
    )
}

export default PersonalisationPreview